import { render } from "./UserDisplay.vue?vue&type=template&id=4fe4e112"
import script from "./UserDisplay.vue?vue&type=script&lang=js"
export * from "./UserDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__